// extracted by mini-css-extract-plugin
export default {"AppStyle":"App_AppStyle__IZPhY"};